import Antecipei from './antecipei';
import Contrato from './contrato';
import Emails from './emails';
import Operacional from './operacional';

const getFieldGroups = (isEdit) => {
  const groups = new Map([
    ['Contrato', Contrato.filter((f) => !f.removed)],
    ['Operacional', Operacional.filter((f) => !f.removed)],
    ['Antecipei', Antecipei.filter((f) => !f.removed)],
  ]);
  if (!isEdit) {
    groups.set('Emails', Emails.filter((f) => !f.removed));
  }
  return groups;
};

export default getFieldGroups;
